<script setup>
import {
  ArrowLeft,
  ArrowRight,
} from 'lucide-vue-next';

const props = defineProps({
  hasNextPagination: Boolean,
  page: {
    default: 1,
    type: Number,
  },
});

const emit = defineEmits(['changePage']);

function nextPage() {
  if (props.hasNextPagination) emit('changePage', props.page + 1);
}

function previousPage() {
  if (props.page > 1) emit('changePage', props.page - 1);
}
</script>

<template>
  <div class="d-flex gap-3">
    <button
      class="btn btn-secondary"
      :disabled="page === 1"
      @click="previousPage()"
      type="button"
    >
      <ArrowLeft height="12" /> Anterior
    </button>
    <button
      class="btn btn-primary m-10"
      :disabled="!hasNextPagination"
      @click="nextPage()"
      type="button"
    >
      Próxima
      <ArrowRight height="12" />
    </button>
  </div>
</template>
